import { CreateArchivePayload } from "../types";
import axios from "../utils/axios";
import Axios from "axios";

export function archiveContent(body: CreateArchivePayload, token: string) {
  return new Promise(function (resolve, reject) {
    axios
      .post(`/archive`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((error) => {
        if (Axios.isCancel(error)) return;
        reject(error);
      });
  });
}

export function unArchiveContent(contentId: string, token: string) {
  return new Promise(function (resolve, reject) {
    axios
      .patch(
        `/archive/${contentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function getAllArchiveContent(token: string) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`/archive/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}
